// extracted by mini-css-extract-plugin
export default {"container":"settings_container__UAmso","row":"settings_row__XJHwv"};